
const ES = {
    table: {
        columns: {
            id: 'ID',
            period: 'Período',
            amount: 'Monto',
            applies: 'Aplica a',
            created: 'Fecha de alta',
            updated: 'Fecha de modificación',
            status: 'Estado',
        },
    },
    period: {
        day: 'Diario',
        month: 'Mensual',
    },
    levels: {
        1: 'Diamante',
        2: 'Zafiro',
        3: 'Oro',
        4: 'Plata',
        5: 'Bronce'
    },
    status: {
        0: 'Inactivo',
        1: 'Activo',
    }

};

export default ES;
